import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import moment from 'moment-jalali';

const initialValues = {
};

const validationSchema = Yup.object({
});

const activeCase = [
    {
        id: 0,
        title: "غیر فعال"
    }, {
        id: 1,
        title: "فعال"
    }
]

const inputTypeCase = [
    {
        id: 0,
        type: "متن",
        title: ""
    }, {
        id: 1,
        type: "عدد",
        title: ""
    }, {
        id: 2,
        type: "تاریخ",
        title: ""
    }
]


const Create = () => {

    const { addData: addDataSubService } = useEntityCrud('SubService/SetSubService')
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')
    const { addData: addDataTemplateValues } = useEntityCrud('SubService/SetSubService_TemplateValues')
    const { addData: addSubServiceImage } = useEntityCrud('SubService/SetSubServiceImage')
    const { addData: addSubServiceCount } = useEntityCrud('SubService/setsubServiceStock')

    const [businessList, setBusinessList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [activeList, setActiveList] = useState([]);
    const [createDate, setCreateDate] = useState(null)
    const { isEditMode, setIsEditMode } = (false)
    const navigate = useNavigate();
    const [serviceList, setServiceList] = useState([]);
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: "",
        serviceId: ""
    })
    const [path, setPath] = useState([
        {
            type: "",
            title: "",
            templateValues: ""
        },
    ])


    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("jYYYYjMMjDD")
    }


    useEffect(() => {
        readDataBusiness().then(res => {
            setBusinessList(res.data.result)
        });
        const postedData = {
            "title": "",
            "discountCode": ""
        };
        setActiveList(activeCase.map(item => ({ value: item.id, label: item.title })))
    }, [])



    const onSubmit = (values) => {
        var priceArray = values.price.split(",");
        const postedData = {
            title: values.title,
            isActive: 0,
            description: values.description || "",
            serviceId: orgAddress.serviceId.value,
            rules: orgAddress.rules,
            discountId: 0,
            createDate: parseInt(convertToDate("")),
            price: parseInt(priceArray[0] + priceArray[1] + priceArray[2]),
            discount: parseInt(values.discount || 0),
            specialPrice: values.specialPrice ? parseInt(values.specialPrice.toString().replace(/,/g,'')) : 0,
            specialQuantity: values.specialQuantity ? parseInt(values.specialQuantity) : 0,
            specialFromDate: values.specialFromDate ? parseInt(values.specialFromDate.toString().replace(/\//g,'')) : 0,
            specialFromTime: values.specialFromTime ? parseInt(values.specialFromTime.toString().replace(':','')) : 0,
            specialtoDate: values.specialtoDate ? parseInt(values.specialtoDate.toString().replace(/\//g,'')) : 0,
            specialtoTime: values.specialtoTime ? parseInt(values.specialtoTime.toString().replace(':','')) : 0
        };
        addDataSubService(postedData).then(res => {
             

            if (res.status === 200) {

                if(values.image){
                    const imagePostedData = {
                        imageContent: values.image.split('base64,')[1],
                        subserviceId: res.data.result.id
                    };
                    addSubServiceImage(imagePostedData)
                }

                const stockPostedData = {
                    subServiceId: res.data.result.id,
                    stockMode: parseInt(values.stockType),
                    quantity: parseInt(values.stockQuantity)
                }
                addSubServiceCount(stockPostedData)

                const string = JSON.stringify(path);
                const bodyValue = {
                    "subServiceId": res.data.result.id,
                    "templateValues": string,
                }

                addDataTemplateValues(bodyValue).then(res0 => {
                     
                    console.log(res0);
                })


                if (res.data.status === false) {
                    res.data.errors.map(error => toast.error(error.message));
                }
                else {
                    navigate("/subService");
                    toast.success('محصول/خدمت  با موفقیت در سیستم ثبت شد.');
                }
            } else
                res.data.errors.map(error => toast.error(error.message));
        })
    }


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        validationSchema: validationSchema
    });


    const handleBack = () => {
         
        navigate('/subService', { replace: true });
    }


    return (
        <div className="card">
            <div className="card-header  d-flex justify-content-between">
                <div className="card-title">
                    {/*                     <i className='fa fa-plus px-1'></i>
 */}                    ایجاد محصول/خدمت  جدید  </div>
                <a className='backIconLink' onClick={handleBack}> <i className='fa fa-arrow-left'
                    title="بازگشت"> </i> </a>
            </div>
            <div className="card-body">
                <Form formik={formik}
                    path={path}
                    setPath={setPath}
                    isEditMode={false}
                    serviceList={serviceList} activeList={activeList}
                    createDate={createDate} setCreateDate={setCreateDate}
                    setServiceList={setServiceList}
                    groupList={groupList} setGroupList={setGroupList}
                    businessList={businessList} setBusinessList={setBusinessList}
                    orgAddress={orgAddress} setOrgAddress={setOrgAddress} />
            </div>
        </div>
    );

}

export default Create;